import * as React from 'react'
import { ImageUrl } from '../../../../dvui/utils/imageUtils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as st from './packshot.module.scss'
import * as heroSt from './heroshot.module.scss'
import { CirclePlayButton } from '../circlePlayButton/circlePlayButton'
import * as cn from 'classnames'
import { ResponsiveImage } from '../images/responsiveImage'
import { IPlaybackStart } from '../../actions/player'
import { PlaybackContentLink } from '@shared'

export interface IPackshotProps {
  packshot?: string
  playbackData?: WpsRuntime.atv.wps.PlaybackActionDataProps
  sessionId: string
  pageTitleId: string
  isRetail: boolean
  isTV?: boolean
  usePlayer: boolean
  startPlayback: (content: PlaybackContentLink) => IPlaybackStart
}

export const Packshot = ({ packshot, playbackData, sessionId, pageTitleId, isRetail, isTV, startPlayback, usePlayer }: IPackshotProps) => {
  if (!packshot) {
    return null
  }
  const background = new ImageUrl(packshot)
    .scaleWidth(300)
    .setBlur(80)
    .getImageUrl()

  const backgroundPackshotStyle = {
    backgroundImage: `url(${background})`
  }

  const packshotImgProps = {
    alt: '', // Decorative image so no alt
    src: packshot,
    baseValue: 300,
  }

  const packshotClassNames = cn(
    st.packshot,
    isTV ? st.seasonPackshot : undefined,
    'dv-fallback-packshot-image'
  )

  return (
    <React.Fragment>
      <div className={`${heroSt.avHeroBackground} ${st.packshotBackground}`}
           data-automation-id="hero-background" style={backgroundPackshotStyle}>
        <div className={heroSt.avHeroBackgroundFadeLeft}/>
        <div className={heroSt.avHeroBackgroundFadeBottom}/>
      </div>
      <div className={packshotClassNames}>
        <ResponsiveImage {...packshotImgProps} />
        {isRetail && (
          <div className="playback-large-circle-wrapper">
            <div id="dv-play-box-circle">
              {playbackData && (
                <CirclePlayButton playbackData={playbackData} sessionId={sessionId} pageTitleId={pageTitleId} isPackshot startPlayback={startPlayback} usePlayer={usePlayer}/>
              )}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}
